var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    viewBox: "68 -892 824 824",
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480-360q50 0 85-35t35-85-35-85-85-35-85 35-35 85 35 85 85 35m-.23 32q-63.62 0-107.69-44.3Q328-416.61 328-480.23t44.3-107.69Q416.61-632 480.23-632t107.69 44.3Q632-543.39 632-479.77t-44.3 107.69Q543.39-328 479.77-328M216-464H68v-32h148zm676 0H744v-32h148zM464-744v-148h32v148zm0 676v-148h32v148zM282.85-655.85l-88.39-86.92 21.77-25.77 90.46 89.39zm460.92 460.39-88.69-85.62 22.07-24.07 88.39 87.92zm-89.92-481.69 88.92-86.39 21.77 19.77-85.39 91.46zM191.46-216.23l89.62-86.69 20.54 20.07-84.16 90.16zM480-480"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightMode);
export default __webpack_public_path__ + "static/media/light_mode.d025e79f91dc25ab6c2ffdd70658d250.svg";
export { ForwardRef as ReactComponent };